export enum AdSection {
  BANNER = 'BANNER',
  SIDEBAR = 'SIDEBAR',
  INTERSTITIAL = 'INTERSTITIAL',
}
